import React from "react";
import { Route, Routes } from "react-router-dom";
import "./styles/DashboardStyle.css";
import Home from "../home";
import { OpenBankingProvider } from "../location/context/OpenBankingContext";
interface dashboardProps {}

const Dashboard: React.FC<dashboardProps> = (props) => {
  return (
    <OpenBankingProvider>
      <Routes>
        <Route path="/home" element={<Home />} />
      </Routes>
    </OpenBankingProvider>
  );
};

export default Dashboard;
